import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import Statistics from './components/Statistics/Statistics';
import About from './components/About/About';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Gameplay from './components/Gameplay/Gameplay';
import Games from './pages/Games/Games';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AudioProvider } from './context/AudioContext';
import './styles/main.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    // You can add a loading spinner here if you want
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <AudioProvider>
          <ThemeProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              <Route element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              } path="/*">
                <Route index element={<Dashboard />} />
                <Route path="games" element={<Games />} />
                <Route path="game/:gameId" element={<Gameplay />} />
                <Route path="statistics" element={<Statistics />} />
                <Route path="about" element={<About />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </ThemeProvider>
        </AudioProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
